var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"mx-2",attrs:{"to":_vm.path,"color":"primary","disabled":_vm.disabled}},[_c('v-icon',[_vm._v("mdi-compare")]),_vm._v("Compare")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }